import { PaymentServiceAccountStatus } from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

const ShouldBeOnboardedStatuses = new Set([
  PaymentServiceAccountStatus.ACCOUNT_CREATED,
  PaymentServiceAccountStatus.ACCOUNT_NEEDS_UPDATE,
  PaymentServiceAccountStatus.INSTANT_PAYOUT_PENDING,
  PaymentServiceAccountStatus.STANDARD_PAYOUT_PENDING,
]);

export const shouldOnboardToStripe = (
  paymentAccountStatus: PaymentServiceAccountStatus | undefined
) => {
  if (!isDefined(paymentAccountStatus)) {
    return false;
  }

  return ShouldBeOnboardedStatuses.has(paymentAccountStatus);
};

export function useShouldBeOnboardedToStripe() {
  const worker = useDefinedWorker();

  const isWorkerPendingInPaymentService =
    worker.canBeOnboardedInStripe && shouldOnboardToStripe(worker.paymentAccountInfo?.status);

  return Boolean(isWorkerPendingInPaymentService);
}
